import { httpCreate } from './http';

const http = httpCreate('/srv/watermark-config');

export const watermarkConfig = {
	update(id, data) {
		return http.post(`/${id}`, data);
	},
	get(id) {
		return http.get(`/${id}`);
	}
};
